import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-100 rounded-t-2xl" }
const _hoisted_2 = { class: "text-[17px] font-bold text-slate-900" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center py-16"
}
const _hoisted_4 = {
  key: 1,
  class: "overflow-y-auto px-6 py-5 flex flex-col gap-5"
}
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold text-amber-800"
}
const _hoisted_7 = {
  key: 1,
  class: "font-semibold text-slate-600"
}
const _hoisted_8 = { class: "bg-slate-50 rounded-xl p-4 border border-slate-100 flex flex-col gap-3" }
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = { class: "flex items-start gap-3" }
const _hoisted_11 = { class: "flex justify-end pt-1" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "text-slate-400"
}
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-slate-400 italic text-center py-4"
}
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_16 = {
  class: "flex flex-col items-center flex-shrink-0",
  style: {"width":"20px"}
}
const _hoisted_17 = {
  key: 0,
  class: "flex-1 border-l-2 border-dashed border-slate-200 mt-1",
  style: {"min-height":"32px"}
}
const _hoisted_18 = { class: "pb-5 flex-1" }
const _hoisted_19 = { class: "text-sm font-semibold text-slate-800" }
const _hoisted_20 = { class: "text-xs text-slate-400 mt-0.5" }
const _hoisted_21 = { class: "font-medium text-slate-500" }
const _hoisted_22 = { class: "pt-1 pb-1" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "w-4 h-4 rounded-full border-2 border-white/40 border-t-white animate-spin"
}
const _hoisted_25 = { class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-100 rounded-t-2xl" }
const _hoisted_26 = { class: "overflow-y-auto bg-slate-100 px-6 py-6" }
const _hoisted_27 = ["srcdoc"]

import { ref, watch, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import { UPDATE_STATUS_PENGAJUAN } from '@/store/pengajuanBantuan.module'
import type { PengajuanBantuan, StatusPengajuan } from '@/store/pengajuanBantuan.module'
import { STATUS_LABELS } from '@/utils/statusLabels'
import AppSelect from '@/components/input/AppSelect.vue'
import ConfirmDialog from '@/components/modal/ConfirmDialog.vue'
import { buildEmailPreviewDocument } from '@/utils/emailPreviewRenderer'
import logoBlueUrl from '@/assets/image/IOM-ITB-PrimaryLogo-blue.png'
import logoWhiteUrl from '@/assets/image/IOM-ITB-PrimaryLogo-white.png'

const FALLBACK_EMAIL_BODY = `Halo {{name}},

Status pengajuan bantuan Anda telah diperbarui. Berikut detail terbaru:

ID Pengajuan: {{submission_id}}
Status: {{status}}
{{catatan_line}}
Waktu Update: {{updated_at}}

Silakan login ke sistem untuk melihat detail pengajuan Anda.

Terima kasih,
Tim Pengajuan Bantuan IOM ITB`


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateStatusPengajuan',
  props: {
    modelValue: { type: Boolean },
    item: {},
    loading: { type: Boolean }
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

const EMAIL_STATUS_LABELS: Record<string, string> = {
  VERIFIKASI_BERKAS: 'Sedang Dalam Proses Verifikasi Berkas',
  DIPANGGIL_WAWANCARA: 'Dipanggil Wawancara',
  KEPUTUSAN_DITERIMA: 'Keputusan Akhir Diterima',
  KEPUTUSAN_DITOLAK: 'Keputusan Akhir Ditolak',
  TIDAK_DIKETAHUI: 'Tidak Diketahui',
}

// Fetched from the DB template so preview stays in sync with what is actually sent
const emailTemplateBody    = ref('')
const emailTemplateSubject = ref('')

onMounted(async () => {
  try {
    const res       = await axios.get(`${API_URL}/email-templates`)
    const templates = Array.isArray(res.data) ? res.data : []
    const t         = templates.find((x: any) => x.key === 'pengajuan_bantuan_status_update')
    if (t) {
      emailTemplateBody.value    = t.body    || ''
      emailTemplateSubject.value = t.subject || ''
    }
  } catch {
    // fail silently, preview falls back to inline default
  }
})

const statusOptions = [
  { value: 'TIDAK_DIKETAHUI',    label: 'Status Tidak Diketahui' },
  { value: 'VERIFIKASI_BERKAS',  label: 'Verifikasi Berkas' },
  { value: 'DIPANGGIL_WAWANCARA', label: 'Dipanggil Wawancara' },
  { value: 'KEPUTUSAN_DITERIMA', label: 'Keputusan Diterima' },
  { value: 'KEPUTUSAN_DITOLAK',  label: 'Keputusan Ditolak' },
]

const props = __props

const emit = __emit

const store = useStore()

const formStatus     = ref<StatusPengajuan>('TIDAK_DIKETAHUI')
const formKeterangan = ref('')
const showEmailPreview = ref(false)

watch(
  () => props.item,
  (val) => {
    if (val) {
      formStatus.value     = val.status
      formKeterangan.value = val.catatan ?? ''
    }
  },
  { immediate: true },
)

const recipientEmail = computed(() => props.item?.answersByLabel?.Email ?? '')
const recipientName  = computed(() => props.item?.answersByLabel?.Nama  ?? '')

const hasChanges = computed(() => {
  if (!props.item) return false
  return (
    formStatus.value !== props.item.status ||
    formKeterangan.value !== (props.item.catatan ?? '')
  )
})

const simpanConfirmMessage = computed(() => {
  const label = STATUS_LABELS[formStatus.value] ?? formStatus.value
  if (recipientEmail.value) {
    return `Status pengajuan #${props.item?.id} akan diubah menjadi "${label}" dan notifikasi email dikirim ke ${recipientEmail.value}. Lanjutkan?`
  }
  return `Status pengajuan #${props.item?.id} akan diubah menjadi "${label}". Tidak ada email pemohon, perubahan disimpan tanpa notifikasi. Lanjutkan?`
})

const emailPreviewIframeHtml = computed(() => {
  const statusLabel  = EMAIL_STATUS_LABELS[formStatus.value] ?? formStatus.value ?? 'Tidak Diketahui'
  const nowStr       = new Date().toLocaleString('id-ID', {
    day: '2-digit', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta',
  })
  const catatanLine  = formKeterangan.value ? `Catatan: ${formKeterangan.value}` : ''

  const vars: Record<string, string> = {
    name:         recipientName.value || '-',
    submission_id: props.item?.tallySubmissionId || '-',
    status:       statusLabel,
    catatan_line: catatanLine,
    updated_at:   nowStr,
  }

  let body = emailTemplateBody.value || FALLBACK_EMAIL_BODY
  for (const [k, v] of Object.entries(vars)) {
    body = body.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v)
  }

  return buildEmailPreviewDocument({
    title: 'Update Status Pengajuan Bantuan',
    bodyText: body,
    logoBlueUrl,
    logoWhiteUrl,
  })
})

const showCloseConfirm  = ref(false)
const showSimpanConfirm = ref(false)
const isSaving          = ref(false)

const handleClose = () => {
  if (hasChanges.value) {
    showCloseConfirm.value = true
  } else {
    doClose()
  }
}

const doClose = () => {
  showCloseConfirm.value = false
  showEmailPreview.value = false
  formStatus.value       = 'TIDAK_DIKETAHUI'
  formKeterangan.value   = ''
  emit('update:modelValue', false)
}

const handleSimpan = () => {
  showSimpanConfirm.value = true
}

const doSimpan = async () => {
  showSimpanConfirm.value = false
  if (!props.item) return

  isSaving.value = true
  try {
    await store.dispatch(`pengajuanBantuan/${UPDATE_STATUS_PENGAJUAN}`, {
      tallySubmissionId: props.item.tallySubmissionId,
      status: formStatus.value,
      keterangan: formKeterangan.value,
    })
    emit('update:modelValue', false)
    emit('saved')
  } catch (error: unknown) {
    await Swal.fire({
      icon: 'error',
      title: 'Gagal menyimpan',
      text: error instanceof Error ? error.message : 'Terjadi kesalahan saat menyimpan perubahan.',
      confirmButtonColor: '#2563eb',
    })
  } finally {
    isSaving.value = false
  }
}

const formatDateTime = (iso?: string) => {
  if (!iso) return '-'
  return new Date(iso).toLocaleString('id-ID', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "popup" }, {
        default: _withCtx(() => [
          (__props.modelValue)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4",
                onClick: handleClose
              }, [
                _createElementVNode("div", {
                  class: "bg-white rounded-2xl w-full max-w-[540px] shadow-2xl flex flex-col max-h-[90vh]",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-[13px] font-bold text-blue-600 mb-0.5" }, "Update Status", -1)),
                      _createElementVNode("h2", _hoisted_2, "#" + _toDisplayString(__props.item?.id), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: handleClose,
                      class: "w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all"
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1)
                    ]))])
                  ]),
                  (__props.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("div", { class: "w-8 h-8 rounded-full border-[3px] border-slate-200 border-t-blue-800 animate-spin" }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex items-start gap-3 rounded-xl border px-4 py-3", recipientEmail.value ? 'bg-amber-50 border-amber-200' : 'bg-slate-50 border-slate-200'])
                        }, [
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["w-5 h-5 flex-shrink-0 mt-0.5", recipientEmail.value ? 'text-amber-500' : 'text-slate-400']),
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                            }, null, -1)
                          ]))], 2)),
                          _createElementVNode("div", _hoisted_5, [
                            (recipientEmail.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Pemohon akan dinotifikasi via email"))
                              : (_openBlock(), _createElementBlock("p", _hoisted_7, "Tidak ada email pemohon")),
                            _createElementVNode("p", {
                              class: _normalizeClass(["mt-0.5", recipientEmail.value ? 'text-amber-700' : 'text-slate-500'])
                            }, [
                              (recipientEmail.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[15] || (_cache[15] = _createTextVNode(" Setelah disimpan, notifikasi dikirim ke ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(recipientEmail.value), 1),
                                    _cache[16] || (_cache[16] = _createTextVNode(" berisi status terbaru dan catatan yang Anda isi. ", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Tidak ada email yang ditemukan pada data pengajuan ini. Perubahan status akan disimpan tanpa notifikasi. ")
                                  ], 64))
                            ], 2)
                          ])
                        ], 2),
                        _createElementVNode("section", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-sm font-semibold text-slate-500 mb-3" }, "Perubahan Status", -1)),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500 w-20 flex-shrink-0" }, "Status", -1)),
                              _createVNode(AppSelect, {
                                modelValue: formStatus.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formStatus).value = $event)),
                                options: statusOptions,
                                class: "flex-1"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-medium text-slate-500 w-20 flex-shrink-0 pt-2" }, "Catatan", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formKeterangan).value = $event)),
                                rows: "3",
                                placeholder: "Tambahkan catatan (opsional)...",
                                class: "flex-1 px-3 py-2 text-sm text-slate-700 bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 transition-all resize-none placeholder-slate-400"
                              }, null, 512), [
                                [_vModelText, formKeterangan.value]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (showEmailPreview.value = true)),
                                disabled: !recipientEmail.value,
                                class: _normalizeClass(["inline-flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-semibold rounded-lg border transition-all", recipientEmail.value
                    ? 'text-slate-600 bg-white border-slate-200 hover:bg-slate-50 hover:border-slate-300'
                    : 'text-slate-400 bg-slate-50 border-slate-200 cursor-not-allowed'])
                              }, [
                                _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                  class: "w-3.5 h-3.5",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                                  })
                                ], -1)),
                                _cache[20] || (_cache[20] = _createTextVNode(" Preview Email ", -1)),
                                (!recipientEmail.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(tidak ada email)"))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_12)
                            ])
                          ])
                        ]),
                        _createElementVNode("section", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-sm font-semibold text-slate-500 mb-3" }, "Riwayat Perubahan", -1)),
                          (!__props.item?.riwayat?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Belum ada riwayat perubahan. "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.riwayat, (rw, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: rw.id,
                                    class: "flex gap-4 relative"
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-blue-800 ring-2 ring-blue-100 flex-shrink-0 mt-0.5 z-10" }, null, -1)),
                                      (idx < __props.item.riwayat.length - 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("p", _hoisted_19, _toDisplayString(rw.keterangan), 1),
                                      _createElementVNode("p", _hoisted_20, [
                                        _createTextVNode(_toDisplayString(formatDateTime(rw.waktu)) + " · oleh ", 1),
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(rw.oleh), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            onClick: handleSimpan,
                            disabled: isSaving.value,
                            class: "w-full py-3 rounded-xl text-sm font-bold text-white bg-blue-800 hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed transition-all shadow-sm flex items-center justify-center gap-2"
                          }, [
                            (isSaving.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(isSaving.value ? 'Menyimpan...' : 'Simpan Perubahan'), 1)
                          ], 8, _hoisted_23)
                        ])
                      ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "popup" }, {
        default: _withCtx(() => [
          (showEmailPreview.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showEmailPreview.value = false))
              }, [
                _createElementVNode("div", {
                  class: "bg-white rounded-2xl w-full max-w-[620px] shadow-2xl flex flex-col max-h-[90vh]",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                      _createElementVNode("p", { class: "text-[13px] font-bold text-slate-400 mb-0.5" }, "Pratinjau"),
                      _createElementVNode("h3", { class: "text-[16px] font-bold text-slate-900" }, "Email yang Akan Dikirim")
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showEmailPreview.value = false)),
                      class: "w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all"
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1)
                    ]))])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("iframe", {
                      srcdoc: emailPreviewIframeHtml.value,
                      class: "w-full border-0",
                      style: {"height":"650px"},
                      sandbox: "allow-same-origin"
                    }, null, 8, _hoisted_27),
                    _cache[26] || (_cache[26] = _createElementVNode("p", { class: "mt-4 text-xs text-center text-slate-400" }, " * Logo dan waktu pengiriman yang tepat dapat berbeda pada email sebenarnya. ", -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    _createVNode(ConfirmDialog, {
      modelValue: showSimpanConfirm.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showSimpanConfirm).value = $event)),
      title: "Simpan Perubahan?",
      message: simpanConfirmMessage.value,
      "confirm-label": "Ya, Simpan",
      "cancel-label": "Batal",
      variant: "primary",
      "icon-variant": "info",
      onConfirm: doSimpan,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (showSimpanConfirm.value = false))
    }, null, 8, ["modelValue", "message"]),
    _createVNode(ConfirmDialog, {
      modelValue: showCloseConfirm.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showCloseConfirm).value = $event)),
      title: "Buang Perubahan?",
      message: "Ada perubahan yang belum disimpan. Jika Anda menutup dialog ini, perubahan akan hilang.",
      "confirm-label": "Ya, Tutup",
      "cancel-label": "Tetap di sini",
      variant: "danger",
      "icon-variant": "danger",
      onConfirm: doClose,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (showCloseConfirm.value = false))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})